import React, { useEffect } from "react";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import setAuthToken from "./utils/setAuthToken";
import { setCurrentUser, logoutUser } from "./actions/authActions";
import { GoogleOAuthProvider} from '@react-oauth/google';
import { Provider } from "react-redux";
import store from "./store";
import Main from "./components/layouts/MainComponent";
import "./App.css";

const App = () => {
    const [setShowModal, setSetShowModal] = React.useState(false); // example
    const theme = createTheme({
      palette: {
        primary: { main: '#1976d2' },
        background: { paper: '#fff' },
      },
    }); 


  useEffect(() => {
    const token = localStorage.jwtToken;
    if (token) {
      setAuthToken(token);

      try {
        const decoded = jwtDecode(token);
        store.dispatch(setCurrentUser(decoded));

        const currentTime = Date.now() / 1000;
        if (decoded.exp < currentTime) {
          store.dispatch(logoutUser());
          window.location.href = "/login";
        }
      } catch (error) {
        console.error("Token decode error:", error);
        store.dispatch(logoutUser());
        window.location.href = "/login";
      }
    }
  }, []);

  return (
    <Provider store={store}>
      {/* <GoogleOAuthProvider clientId="1091455767511-r42ffo1onsdj52u8hb0771dp3l5h2h5d.apps.googleusercontent.com"> */}
        <BrowserRouter>
          <ThemeProvider theme={theme}>
                <Main setShowModal={setShowModal} />
          </ThemeProvider>
        </BrowserRouter>
      {/* </GoogleOAuthProvider> */}
    </Provider>
  );
};

export default App;
